import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import ListGroup from "react-bootstrap/esm/ListGroup";
import {kwToHp} from "../utils/vehicles";

function FavouritesPanel({
                        favourites,
                        onOpenVehicle,
                        onRemoveFavourite,
                        selectedVehicle
                    }) {
    function powerDifferenceIndication(vehicle, selectedVehicle) {
        if (!selectedVehicle){
            return "";
        }
        var difference = kwToHp(selectedVehicle?.powerKw) - kwToHp(vehicle.powerKw);
        if (difference < 0) {
            return `(${difference})`;
        } else {
            return `(+${difference})`;
        }
    }
    function powerDifferenceRowColor(vehicle, selectedVehicle) {
        if (!selectedVehicle){
            return "";
        }
        var difference = kwToHp(selectedVehicle?.powerKw) - kwToHp(vehicle.powerKw);
        var differencePercent = Math.abs(difference / kwToHp(selectedVehicle?.powerKw) * 100);
        if (difference === 0) {
            return "";
        }
        if (differencePercent < 10) {
            return "text-warning";
        }
        if (difference < 0) {
            return "text-success";
        } else {
            return "text-danger";
        }
    }
    return (
        <Card className="shadow-sm mt-4">
            <Card.Body className="p-4">
                <h2 className="h5 mb-3">Favourites</h2>

                {favourites.length === 0 ? (
                    <p className="mb-0 text-body-secondary">No favourites saved yet.</p>
                ) : (
                    <ListGroup variant="flush">
                        {favourites.map((vehicle) => (
                            <ListGroup.Item
                                key={vehicle.plate}
                                className="px-0 d-flex justify-content-between align-items-start gap-3"
                            >
                                <div>
                                    <Button
                                        className="fw-semibold p-0 text-decoration-none"
                                        variant="link"
                                        onClick={() => onOpenVehicle(vehicle.plate)}
                                    >
                                        {vehicle.plate}
                                    </Button>
                                    <div className="text-body-secondary small">{`${vehicle.manufacturer} ${vehicle.model}`}</div>
                                </div>
                                <div>
                                    <div className={"small " + powerDifferenceRowColor(vehicle, selectedVehicle)}>{kwToHp(vehicle.powerKw)}hp {powerDifferenceIndication(vehicle, selectedVehicle)}</div>
                                    <div className="small">{Math.round(vehicle.displacement / 100) / 10 }L {vehicle.fuel}</div>
                                </div>
                                <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() => onRemoveFavourite(vehicle.plate)}
                                >
                                    Remove
                                </Button>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}
            </Card.Body>
        </Card>
    );
}

export default FavouritesPanel;
